import React from 'react';
import { Badge, BadgeType } from '../../../../../../components/badge/badge';
import { humanizeKey } from '../../profile-explanation-utils';

interface IProfileExplanationHeaderProps {
    capabilityKey: string;
    type: string;
    source: string;
    isDefault: boolean;
    expanded: boolean;
    onToggle: () => void;
}

const ProfileExplanationHeader: React.FC<IProfileExplanationHeaderProps> = ({
    capabilityKey,
    type,
    source,
    isDefault,
    expanded,
    onToggle
}) => {
    return (
        <div
            className="profile-explanation-header"
            onClick={onToggle}
        >
            <div className="profile-explanation-header-left">
                <span className="profile-explanation-capability-name">{humanizeKey(capabilityKey)}</span>
                <span className="profile-explanation-type">({type})</span>
                <Badge
                    type={source === 'configuration' ? BadgeType.SUCCESS : BadgeType.WARNING}
                    text={source === 'configuration' ? 'From configuration' : 'Default'}
                />
            </div>
            <span className="profile-explanation-chevron">{expanded ? '\u25BC' : '\u25B6'}</span>
        </div>
    );
};

export default ProfileExplanationHeader;
